import { ClientTrackingActions } from '@models/ClientTrackingActionType';

export interface ITrackingConfig {
    url: string;
    siteId: number;
}

export interface ITrackingService {
    initPiwik({ url, siteId }: ITrackingConfig): void;
    trackEvent(category: string, name: string, value?: string): void;
    trackClickEvent(category: string, name: string, value?: string): void;
    trackPageView(page: string): void;
    setUserId(userId: string): void;
}

export default class TrackingService implements ITrackingService {

    initPiwik({ url, siteId }: ITrackingConfig): void {
        if (typeof window !== 'undefined') {
            // @ts-ignore
            window._paq = window._paq || [];

            this.push(['setSiteId', siteId]);
            this.push(['setTrackerUrl', `${url}/piwik.php`]);
            this.push(['enableLinkTracking']);

            const scriptElement = document.createElement('script');
            const refElement = document.getElementsByTagName('script')[0];

            scriptElement.type = 'text/javascript';
            scriptElement.defer = true;
            scriptElement.async = true;
            scriptElement.src = `${url}/piwik.js`;

            if (!refElement || !refElement.parentNode) {
                return;
            }

            refElement.parentNode.insertBefore(scriptElement, refElement);
        }
    }

    private push(args: any) {
        // @ts-ignore
        window._paq.push(args);
    }

    /**
     * @deprecated Use trackClickEvent instead as it is more explicit for which action is recorded
     */
    trackEvent(category: string, name: string, value?: string): void {
        this.trackClickEvent(category, name, value);
    }

    trackClickEvent(category: string, name: string, value?: string): void {
        this.push(['trackEvent', category, ClientTrackingActions.Click, name, value]);
    }

    trackPageView(page: string): void {
        this.push(['trackPageView', page]);
    }

    setUserId(userId: string): void {
        this.push(['setUserId', userId]);
    }
}



// WEBPACK FOOTER //
// ./src/services/TrackingService.ts